"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTROLLED_24_7_SCHEDULE = void 0;
var main_api_1 = require("../main-api");
exports.CONTROLLED_24_7_SCHEDULE = {
    type: main_api_1.TimetableRuleType.ALLOWANCE,
    days: [1, 2, 3, 4, 5, 6, 7],
    start: '00:00',
    end: '00:00',
    state: main_api_1.TimetableRuleState.CONTROLLED,
};
//# sourceMappingURL=constants.js.map